<div
  class="cat-button modern-cat-button"
  [ngClass]="{
    'ddc-home-card-light-4': _isLightTheme,
    'ddc-home-card-dark-4': _isDarkTheme,
    'ddc-home-card-paper-4': _isPaperTheme,
  }"
>
  <div class="button-content">
    <mat-icon class="category-icon">category</mat-icon>
    <span class="category-label">{{ _label }}</span>
  </div>
</div>
